import { AboveBelowFieldsContentType } from 'common.types'
import { useTranslation } from 'react-i18next'

export const MailInBallotBelowFieldsContent: React.FC<
  AboveBelowFieldsContentType
> = ({ step }) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: `mailInBallotForm.belowFieldsContent`,
  })

  return (
    <div style={{ fontSize: 12, marginTop: 30 }}>
      <p dangerouslySetInnerHTML={{ __html: t(`disclosureTwo`) }}></p>
      {step === 3 ? (
        <p dangerouslySetInnerHTML={{ __html: t(`penalty`) }} />
      ) : null}
      <p dangerouslySetInnerHTML={{ __html: t(`disclosureFour`) }}></p>
    </div>
  )
}
